import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { products } from '../Data/products';
import '../styles/ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // Simulate API call with delay
        await new Promise(resolve => setTimeout(resolve, 500));
        const foundProduct = products.find(p => p.id === parseInt(id));
        setProduct(foundProduct);
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (isLoading) {
    return <div className="loading">Loading product details...</div>;
  }

  if (!product) {
    return <div className="product-not-found">Product not found</div>;
  }

  return (
    <div className="product-detail-container">
      <div className="product-header">
        <h1>{product.name}</h1>
      </div>

      <div className="product-image-container">
        <img 
          src={product.image} 
          alt={product.name} 
          className="product-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/images/placeholder.jpg';
          }}
        />
      </div>

      <div className="product-content">
        <h2 className="product-title">{product.name} – {product.category}</h2>

        <div className="product-section">
          <h3>Product Overview</h3>
          <p>{product.description}</p>
        </div>

        <div className="product-section">
          <h3>Key Ingredients</h3>
          <ul>
            {product.ingredients.map((ingredient, index) => (
              <li key={index}>{ingredient}</li>
            ))}
          </ul>
        </div>

        <div className="product-section">
          <h3>Packaging Details</h3>
          <ul>
            {product.packaging.map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div>

        <div className="product-section">
          <h3>Benefits</h3>
          <ul className="benefits-list">
            {product.benefits.map((benefit, index) => (
              <li key={index}>
                {/* <span className="check-icon">✓</span>  */}
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        <div className="product-section">
          <h3>Usage & Dosage</h3>
          <p>{product.usage}</p>
        </div>

        <div className="product-section">
          <h3>Storage Instructions</h3>
          <ul>
            {product.storage.map((instruction, index) => (
              <li key={index}>{instruction}</li>
            ))}
          </ul>
        </div>

        <div className="product-section">
          <h3>Safety Information</h3>
          <ul>
            {product.safety.map((info, index) => (
              <li key={index}>{info}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="call-to-action">
        <Link to="/" className="home-button">
          Return Home
        </Link>
      </div>
    </div>
  );
};

export default ProductDetail;